export default {
  GET_NATIONALITIES_QUERY_SERVICE: Symbol.for('GET_NATIONALITIES_QUERY_SERVICE'),
  NATIONALITY_REPOSITORY: Symbol.for('NATIONALITY_REPOSITORY'),
  ONBOARDING_CATALOG_NATIONALITY_STATE_MANAGER:
    Symbol.for('ONBOARDING_CATALOG_NATIONALITY_STATE_MANAGER'),
};
